export default __webpack_public_path__ + "static/media/fingo-screenshot-05.bbf0ac57.png";